module.exports = __webpack_public_path__ + "assets/img/block-hover-b76cb8b0.png";